import { TZDate } from '@date-fns/tz'
import { format, formatDistance } from 'date-fns'

export function formatDateTime(
  dateTime?: number | Date | string,
  formatString = 'HH:mm:ss | MM/dd/yyyy'
): string {
  // formats dateTime to military time [hh]:[MM]:[ss], [mm]/[dd]/[yyyy]
  return format(dateTime ? new Date(dateTime) : new Date(), formatString)
}

export function formatDateTimeInTimeZone(
  dateTime?: number | Date | string,
  timeZone?: string,
  formatString = 'HH:mm:ss | MM/dd/yyyy'
): string {
  if (!dateTime || !timeZone) {
    return ''
  }

  try {
    return format(
      new TZDate(new Date(dateTime).getTime(), timeZone),
      formatString
    )
  } catch {
    return ''
  }
}

export const formatDate = (dateTime: number | Date | string): string => {
  return dateTime ? format(new Date(dateTime), 'MM/dd/yyyy') : ''
}

export function formatDateTimeWithAt(
  dateTime?: number | Date | string
): string {
  const formatString = 'MM.dd.yyyy  @ HH:mm:ss'

  if (dateTime === undefined) {
    return format(new Date(), formatString)
  }
  try {
    return format(new Date(dateTime), formatString)
  } catch {
    return ''
  }
}

export function formatTimeDistance(dateTime: number | Date | string): string {
  return formatDistance(
    dateTime ? new Date(dateTime) : new Date(),
    new Date(),
    {
      addSuffix: true,
    }
  )
}

export function formatTimeForTableCell(
  dateTime: number | Date | string
): string {
  return `${formatDateTime(dateTime)} • ${formatTimeDistance(dateTime)}`
}

// Reference https://stackoverflow.com/questions/48172772/time-zone-issue-involving-date-fns-format
export function formatDateWithTzOffset(
  dateTime?: number | Date | string,
  formatString = 'MM.dd.yyyy'
): string {
  const dt = new Date(dateTime)
  const dateWithOffset = new Date(
    dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000
  )
  return format(
    dateWithOffset ? new Date(dateWithOffset) : new Date(),
    formatString
  )
}

// Formats the date's own local wall-clock components directly, with no timezone
// conversion at all -- the schedule is sent/stored/displayed as raw local digits
// (see ENG-30856); a timezone is applied exactly once, at evaluation time, using
// the incident's own facility.
export const getLocalTimeString = (date: Date): string =>
  format(date, "yyyy-MM-dd'T'HH:mm:ss")
